import classNames from 'classnames';
// biome-ignore lint/correctness/noUnusedImports: Automated migration to Biome
import React, { useState } from 'react';
import { setImgWidth } from '@/utils/frontify';
import type {
  Contentful,
  FrontifyImageContent,
} from '../../contentful/contentful-exports';
import VideoOverlay from './VideoOverlay';
import useStyles from './VideoPlayer.styles';

export interface VideoContent extends Contentful {
  fields: {
    title?: string;
    thumbnail?: FrontifyImageContent[];
    link?: string;
  };
}

interface VideoPlayerProps {
  content: VideoContent;
  containerStyle?: string;
  smallIcon?: boolean;
}

/**
 * @deprecated V2 component
 */
export function VideoPlayer({
  content: {
    fields: { thumbnail, link },
  },
  containerStyle,
  smallIcon,
}: VideoPlayerProps) {
  const [displayVideoOverlay, setDisplayVideoOverlay] =
    useState<boolean>(false);

  const { classes } = useStyles();
  return (
    <div
      style={{
        background: `linear-gradient(rgba(211,211,211,.5), rgba(211,211,211,.5)), url(${setImgWidth(
          thumbnail?.[0].preview_url,
          1440
        )})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
      className={classNames([classes.defaultVideoContainer, containerStyle])}
    >
      {/** biome-ignore lint/a11y/noStaticElementInteractions: Automated migration to Biome */}
      {/** biome-ignore lint/a11y/useKeyWithClickEvents: Automated migration to Biome */}
      <div
        onClick={() => {
          setDisplayVideoOverlay(true);
        }}
      >
        {/** biome-ignore lint/performance/noImgElement: Automated migration to Biome */}
        <img
          src={'/cmsAssets/assets/img/video/PlayOutline.png'}
          className={smallIcon ? classes.smallIcon : classes.icon}
          alt='video player play outline'
        />
      </div>
      {displayVideoOverlay && (
        <VideoOverlay
          src={link || ''}
          onClose={() => {
            setDisplayVideoOverlay(false);
          }}
        />
      )}
    </div>
  );
}
